<template>
  <div>
    <Pie :data="datacollection" :options="chartOptions" />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  name: 'PieChart',
  components: { Pie },
  props: {
    datacollection: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' },
          title: { display: true, text: 'Concentração' }
        }
      }
    }
  },
  watch: {
    // Se o objeto datacollection mudar, o gráfico será atualizado.
    datacollection: {
      handler(newVal) {
        // Se necessário, você pode forçar uma atualização aqui.
      },
      deep: true
    }
  }
}
</script>

<style scoped>
div {
  position: relative;
  height: 400px;
}
</style>
